import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'

const InteractorShippingHeaderCreate = () => {
  const { t } = useTranslation()
  const shippingHeaderCreate = useCallback(
    (payload, callback = () => {}, loading = () => {}) => {
      const uidTransaction = payload.transaction_uid
      ApiService.jsonRequest('/transaction-shipping-header/create', payload, (response) => {
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.data_has_been_added`),
            timer: 2000,
            redirect: `/order/shipping?uid=${uidTransaction}`,
          })
          callback(response.data)
        } else {
          const raw = response.messages
          const [key, extra] = raw.split(': ')
          const message = extra
            ? `${t(`response_message.${key}`)} ${extra}`
            : t(`response_message.${key}`)
          showAlert({
            icon: 'error',
            message: message,
            timer: 2000,
          })
        }
        loading(false)
      })
    },
    [t],
  )
  return { shippingHeaderCreate }
}

export default InteractorShippingHeaderCreate
